<template>
  <div>
    <div class="grid grid-cols-[1.8fr,1rem,1fr] gap-8" v-if="walletData">
      <div class="text-left space-y-4.2">
        <p class="flex justify-between items-end">
          <span class="font-bold text-xl">{{
            $t("余额") + "（CNY）"
          }}</span>
          <span @click="gohelp">
            <el-link :underline="false" class="">
              <span
                class="iconfont icon-yiwen relative top-2px text-hex-3298F0"
              ></span>
              <span class="text-hex-3298F0">{{ $t("交易规则说明") }}</span>
              <span
                class="iconfont icon-right relative top-1px text-hex-3298F0"
              ></span>
            </el-link>
          </span>
        </p>
        <p class="text-red-500 text-3xl font-bold">￥ {{ walletData.money }}</p>
        <p class="space-x-8">
          <span class="dollar text-red-500"
            >{{ $t("约") }}{{ (walletData.money * 0.16).toFixed(2) }}</span
          >
          <span>1{{ $t("人民币") }}=0.16{{ $t("美元") }}</span>
          <span class="text-gray-400">{{
            $t("数据仅供参考，交易时以银行柜台成交价为准")
          }}</span>
        </p>
        <div class="flex space-x-4">
          <el-button
            class="btn bg-hex-FABB5D"
            @click="recharge"
            size="small"
            type="warning"
          >
            {{ $t("充值") }}
          </el-button>
          <!-- <el-button
            class="btn bg-hex-FABB5D"
            @click="dialogPayVisible = true"
            size="small"
            type="warning"
          >
            {{ $t("充值") }}
          </el-button> -->
          <el-button
            class="btn bg-hex-FA9A08"
            type="warning"
            @click="withdrawal"
            size="small"
          >
            {{ $t("提现") }}
          </el-button>
        </div>
      </div>
      <p class="w-4 h-4 bg-mainGray py-30 -mt-8 -mb-8 m-auto"></p>
      <div class="space-y-10">
        <p class="text-left text-1.13rem">{{ $t("银行账户") }}</p>
        <div class="flex item-center">
          <p>
            <span
              class="iconfont icon-yinhangka text-hex-FF4747 text-3.68rem"
            ></span>
          </p>
          <p
            class="text-center space-y-4 cursor-pointer ml-25"
            @click="manage_card"
          >
            <span class="block text-0.94rem">{{ $t("银行卡") }}</span>
            <span class="block text-1.13rem text-hex-FF4747">{{
              cardTotal + $t("张")
            }}</span>
          </p>
          <!-- <p class="text-center space-y-4 cursor-pointer" @click="manage_card">
            <span class="block text-0.94rem">储蓄卡</span>
            <span class="block text-1.13rem text-hex-FF4747">2张</span>
          </p> -->
        </div>
        <p
          class="text-hex-3298F0 text-0.88rem cursor-pointer"
          @click="addCard"
          v-if="!cardTotal"
        >
          <span class="iconfont icon-tianjia pr-1 text-0.6rem"></span>
          <span>{{ $t("去添加银行卡") }}</span>
          <span class="iconfont icon-right"></span>
        </p>
        <p
          class="text-hex-3298F0 text-0.88rem cursor-pointer"
          v-else
          @click="manage_card"
        >
          {{ $t("管理银行卡") }}
        </p>
      </div>
    </div>

    <p class="h-4 bg-mainGray -mx-8 mt-8"></p>
    <div v-if="walletData">
      <table class="w-full border-1px mt-12">
        <caption class="text-left text-2xl mb-4">
          <span>{{ $t("明细") }}</span>
        </caption>
        <tr class="bg-gray-200 border-1px h-8">
          <th id="classify">{{ $t("类别") }}</th>
          <th id="time">{{ $t("时间") }}</th>
          <th id="money">{{ $t("金额") }}</th>
          <th id="state">{{ $t("状态") }}</th>
        </tr>
        <tr
          class="border-1px h-10"
          v-for="item in walletData.logs"
          :key="item.id"
        >
          <td class="">
            <div class="text-center">{{ item.reason }}</div>
          </td>
          <td class="border-1px">
            <div class="text-center">
              {{ $formatStamp(item.created.timestamp) }}
            </div>
          </td>
          <td class="border-1px">
            <div class="text-center">{{ item.value }}</div>
          </td>
          <td class="border-1px">
            <div class="text-center">{{ $t("成功") }}</div>
          </td>
        </tr>
      </table>
    </div>
    <el-dialog :visible.sync="dialogPayVisible" width="35%" top="30vh">
      <div class="space-y-10 mb-6 dialog">
        <div class="text-lg font-medium mb-2">{{ $t("在线充值") }}</div>
        <el-input
          :placeholder="$t('请输入充值金额')"
          v-model="payMoney"
          type="number"
          class="w-25.3rem h-3.38rem m-auto mt-5"
        >
          <template slot="append">{{ $t("元") }}</template>
        </el-input>
        <el-button
          class="w-25.3rem h-3.38rem bg-hex-FABB5D border-0 text-1rem"
          type="warning"
          @click="recharge"
          :disabled="disabled"
        >
          {{ $t("立即充值") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ref, onMounted, computed, watchEffect } from "@vue/composition-api";
export default {
  components: {},
  setup(props, ctx) {
    const walletData = ref();
    const dialogPayVisible = ref(false);
    const payMoney = ref(null);
    const card_message = ref();
    const cardLength = computed(() =>
      card_message?.value?.length ? card_message.value.length : 0
    );
    const cardTotal = ref();
    onMounted(async () => {
      walletData.value = (await ctx.root.$callapi("user/getWalletData")).data;
      // card_message.value = (await ctx.root.$callapi("user/getBankCards", { page: 1, size: 10 })).data.items
      const res = await ctx.root.$callapi("user/getBankCards", {
        page: 1,
        size: 10,
      });
      card_message.value = res.data.items;
      cardTotal.value = res.data.total;
    });
    const disabled = ref(true);

    watchEffect(() => {
      disabled.value = payMoney.value ? false : true;
    });
    const recharge = () => {
      ctx.root.$router.push({
        name: "topUp",
        // query: {
        //   payMoney: payMoney.value,
        // },
      });
    };
    const withdrawal = () => {
      ctx.root.$router.push({
        name: "withdrawal",
      });
    };
    const manage_card = () => {
      ctx.root.$router.push({
        name: "manageCard",
      });
    };
    const addCard = () => {
      ctx.root.$router.push({
        name: "addCard",
      });
    };
    const gohelp = () => {
      ctx.root.$router.push({
        name: "serveState",
        query: { tag: "trade_rule" },
      });
    };
    return {
      dialogPayVisible,
      payMoney,
      recharge,
      withdrawal,
      manage_card,
      walletData,
      addCard,
      cardLength,
      disabled,
      cardTotal,
      gohelp,
    };
  },
};
</script>
<style scoped lang="scss">
@import "@/style/stl.scss";
.btn {
  @apply w-9.4rem h-2.3rem text-1rem border-0;
}
.dialog ::v-deep .el-input__inner {
  @apply h-3.38rem;
}
</style>
